export var WALLET;
(function (WALLET) {
    WALLET["METAMASK"] = "MetaMask";
    WALLET["PARTICLE"] = "Particle";
})(WALLET || (WALLET = {}));
